// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1ZloV","name":"ConsentHeader_name__mSgDQ","birthday":"ConsentHeader_birthday__1uaS1","skeleton":"ConsentHeader_skeleton__2oJJT"};